export default "/assets/images/chart-sm-04.82a6d5e625964c06.svg";